module.exports = __webpack_public_path__ + "assets/img/img13.2cd68daa.png";